module.exports = '<svg width="12" height="32" viewBox="0 0 12 32"><path d="M12 26c0-1.106-.894-2-2-2H8a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h2a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4.998c-.552 0-1.226.386-1.48.878C1.276 5.196 0 10.894 0 16c0 5.104 1.276 10.804 3.52 15.122.254.49.928.878 1.48.878h5c1.106 0 2-.894 2-2v-4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/call-2.js
// module id = 1040
// module chunks = 14